import type { FC, ReactNode } from 'react'
import type { DocumentSection } from '@/components/generals/document-page'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { DocumentPage } from '@/components/generals/document-page'
import { siteConfig } from '@/constants/site'

const sections: DocumentSection[] = [
    {
        heading: 'Using this site',
        paragraphs: [
            'By browsing essentia.com or placing an order you agree to these terms. If you do not agree with them, please do not use the site.',
            'You must be at least 18 years old, or have the consent of a parent or guardian, to place an order with us.'
        ]
    },
    {
        heading: 'Orders and pricing',
        paragraphs: [
            'All prices are shown in US dollars and exclude any duties or import taxes that may apply in your country. We reserve the right to correct pricing errors and to cancel an order affected by one, with a full refund.',
            'An order is confirmed only once you receive an order confirmation email from us. Until then we may decline or cancel it, for example when an item is unexpectedly out of stock.'
        ]
    },
    {
        heading: 'Shipping and delivery',
        paragraphs: [
            'We ship all orders within 1-2 business days. Delivery estimates are estimates, not guarantees, and do not account for customs delays outside our control.',
            'Risk of loss passes to you once the carrier has delivered the parcel to the address you provided. Please make sure that address is correct before checking out.'
        ]
    },
    {
        heading: 'Returns and refunds',
        paragraphs: [
            'We offer a 30-day satisfaction guarantee. If you are not completely satisfied, return your product within 30 days of receipt for a full refund of the purchase price.',
            'Products should be returned in their original packaging with at least 75% of the product remaining, so that you can genuinely try it while the policy is not misused.'
        ]
    },
    {
        heading: 'Product information',
        paragraphs: [
            'Nuvéa is a cosmetic product, not a medicine. Nothing on this site is medical advice, and our claims describe cosmetic outcomes observed in testing rather than the treatment of any condition.',
            'If you have a diagnosed skin condition or a known allergy to any listed ingredient, speak to a dermatologist before use.'
        ]
    },
    {
        heading: 'Intellectual property',
        paragraphs: [
            'The Nuvéa name, formula, photography, copy and site design belong to us and may not be reproduced without written permission.'
        ]
    },
    {
        heading: 'Liability',
        paragraphs: [
            'To the extent permitted by law, our liability for any claim relating to a product is limited to the amount you paid for that product. Nothing here limits liability that cannot lawfully be limited.'
        ]
    },
    {
        heading: 'Contact',
        paragraphs: [
            `Questions about these terms can go to ${siteConfig.email}, or by post to ${siteConfig.address}.`
        ]
    }
]

const Terms: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Terms & conditions'
                description='The agreement between you and Nuvéa covering orders, shipping, returns, product information and liability.'
            />

            <DocumentPage
                titleLines={['Terms &', 'Conditions']}
                standfirst='These terms set out the agreement between you and Nuvéa when you browse this site, place an order, or return a product to us.'
                updatedOn='January 2026'
                sections={sections}
            />
        </Layout>
    )
}

export default Terms
